const isArrayCode = `import { isArray } from 'cristatus';

const isArray = isArray([1, 2, 3]); //true
`;

export default isArrayCode;
